export const merch1 = {
  Id: 16,
  MerchantAccountId: 23,
  AccountNumber: "4445027824953",
  Name: "Discovery Discount Group Savings F Vantiv",
  ProcessorName: "Worldpay",
  ProcessorUrl: "https://www.accessmyiq.com/",
  ProcessorFaxOther: null,
  ProcessorAddress: "1600 Prudential Dr",
  ProcessorEmail: null,
  ProcessorFax: null,
  ProcessorCity: "Jacksonville",
  ProcessorState: "FL",
  ProcessorZip: "32207",
  Processor: {
    Id: 4,
    Name: "Worldpay  ",
    URL: "https://www.accessmyiq.com/",
    Email: null,
    Fax: null,
    Notes: "2-8-2023 -- Changed all Reply By to 10 days. (RF)",
    Address: "1600 Prudential Dr",
    City: "Jacksonville",
    State: "FL",
    Zip: "32207",
    RepresentmentEmail: "cbkfax@worldpay.us",
    RepresentmentFax: "15139003456",
    RepresentmentPhone: null,
    SubmissionType: 0,
    SftpHostName: null,
    SftpUserName: null,
    SftpPassword: null,
    SftpDirectory: null,
    ChargebackSourceId: 4,
    TechnologyType: "FILE UPLOAD",
    ProcessorReplyByDays: [
      {
        Id: 4,
        Cycle: "First Chargeback",
        CardBrand: "null",
        ReplyByDays: 10
      },
      {
        Id: 65,
        Cycle: "First Chargeback",
        CardBrand: "AMERICAN EXPRESS",
        ReplyByDays: 10
      },
      {
        Id: 126,
        Cycle: "First Chargeback",
        CardBrand: "DISCOVER",
        ReplyByDays: 10
      },
      {
        Id: 187,
        Cycle: "First Chargeback",
        CardBrand: "MASTERCARD",
        ReplyByDays: 10
      },
      {
        Id: 248,
        Cycle: "First Chargeback",
        CardBrand: "VISA",
        ReplyByDays: 10
      },
      {
        Id: 331,
        Cycle: "Second Chargeback",
        CardBrand: "AMERICAN EXPRESS",
        ReplyByDays: 10
      },
      {
        Id: 395,
        Cycle: "Second Chargeback",
        CardBrand: "DISCOVER",
        ReplyByDays: 10
      },
      {
        Id: 459,
        Cycle: "Second Chargeback",
        CardBrand: "MASTERCARD",
        ReplyByDays: 10
      },
      {
        Id: 523,
        Cycle: "Second Chargeback",
        CardBrand: "VISA",
        ReplyByDays: 10
      },
      {
        Id: 587,
        Cycle: "Second Chargeback",
        CardBrand: "null",
        ReplyByDays: 10
      },
      {
        Id: 651,
        Cycle: "Retrieval Request",
        CardBrand: "AMERICAN EXPRESS",
        ReplyByDays: 10
      },
      {
        Id: 715,
        Cycle: "Retrieval Request",
        CardBrand: "DISCOVER",
        ReplyByDays: 10
      },
      {
        Id: 779,
        Cycle: "Retrieval Request",
        CardBrand: "MASTERCARD",
        ReplyByDays: 10
      },
      {
        Id: 843,
        Cycle: "Retrieval Request",
        CardBrand: "VISA",
        ReplyByDays: 10
      },
      {
        Id: 907,
        Cycle: "Retrieval Request",
        CardBrand: "null",
        ReplyByDays: 10
      }
    ],
    SubmissionTypeDisplay: "Fax",
    ProcessorAdmin: null,
    ProcessorTargetingAdminJson: null,
    ProcessorTargetingAdmin: [],
    SubTypes: null,
    Cycles: null
  },
  Contact: null,
  Address: null,
  Email: null,
  Phone: null,
  City: null,
  State: null,
  Zip: null,
  DBA: "GROUPSAVE 8333270175",
  Company: "Discovery Marketing Group, Inc.",
  ChargeType_Id: 0,
  DeliveryType_Id: 2,
  ProductType_Id: 2,
  AcceptedCardTypes: null,
  Descriptor1: "GROUPSAVE 8333270175",
  Descriptor2: "DISCOUNT GROUP SAVINGS",
  MCC: null,
  CustomerServicePhone: null,
  WebsiteUrl: "http://www.discountgroupsavings.com/",
  SupportEmail: "service@discountgroupsavings.com",
  SupportChat: false,
  SupportPhone: "1-833-272-9549",
  TermsUrl: "http://www.discountgroupsavings.com/terms",
  TermsText: "Your Program membership, in accordance with the membership offer You accepted, is a monthly subscription membership plan, which commences at the earliest of when You receive by mail these Program membership materials or when an email from Us confirming Your enrollment in the Program has been transmitted to You containing Program membership website access information. Please refer to Your membership materials or any welcome email You receive from Us which confirms the Program membership offer. Your membership is effective immediately, unless you cancel, your membership will renew automatically and continues thereafter on a month-to-month basis, during which You will be charged the Program monthly membership fee until membership is cancelled. \r\n\r\nWe reserve the right to increase from time to time the monthly membership fee for the Program commencing after Your first twelve months of membership, with prior notice to You. We will comply with any and all applicable laws with respect to implementing any membership fee increase. You agree that, unless You cancel Your membership prior to the effective date of the membership fee increase, You will be charged the new applicable membership fee of $24.95/month each month thereafter from the effective date of such change, and You authorize Us to charge the new applicable membership fee to Your payment source. The charge will appear on your next credit card statement as DSCNTGRPSV8332729549",
  RefundPolicyUrl: "http://www.discountgroupsavings.com/terms",
  RefundPolicyText: "The purchase of Discount Group Savings monthly subscription is eligible for a refund if requested within 14-days of the date of purchase, or in the case of monthly renewals, within 14-days of the renewal billing date. If you cancel, the membership will not automatically renew next month, however, your benefits will continue for the remaining days in your existing (already paid for) term.",
  CancellationPolicyUrl: "http://www.discountgroupsavings.com/terms",
  CancellationPolicyText: "You have the right at any time to cancel Your membership and terminate further billing at any time on our website 24/7/365, by calling the Program toll free customer service number listed on the Discount Group Savings Membership materials or by writing us at Discount Group Savings; Attn. Membership Services, 848 N. Rainbow Blvd. #2390, Las Vegas, NV 89107, United States. You may also email Us at Service@discountgroupsavings.com. Your cancellation will be effective promptly upon the receipt of Your cancellation request. Upon cancellation, You will not owe any further membership fees.",
  ContactUrl: "http://www.discountgroupsavings.com/contact",
  AccountClassification: "MOTO",
  BusinessDescription: "access to exclusive membership discounts and special offers at over 700,000 local and national retailers and online stores. These discounts are available through the membership website and smartphone application providing dining, shopping, and entertainment discounts at the customer's fingertips.",
  ReturnPolicy: null,
  ReturnPolicyUrl: null,
  ReturnPolicyDays: null,
  StoreName: "Discount Group Savings",
  CorporateMerchantName: "Discovery Marketing Group, Inc.",
  CancelRefundPolicyDisclosure: null
}